import { RootStores } from '../../common/stores';
import { STORE_ROUTER, STORE_PROJECTS_ROOT_UI, STORE_USERS } from '../../common/constants';
import { STORE_TRAINING_PROJECTS, STORE_TRAINING_PROJECT_DASHBOARD } from './constants';
import { MLService } from '../../ml_models/services';
import { ProjectsService } from '../../common/services';
import TrainingProjectsStore from './TrainingProjectsStore';
import TrainingProjectDashboardStore from './TrainingProjectDashboardStore';
import TrainingProjectsService from '../services/TrainingProjectsService';

export { default as TrainingProjectsStore } from './TrainingProjectsStore';
export { default as TrainingProjectDashboardStore } from './TrainingProjectDashboardStore';

export function injectTrainingProjectsStores(obj: RootStores) {
    const service = new TrainingProjectsService();
    const mlService = new MLService();
    const projectsService = new ProjectsService();

    obj[STORE_TRAINING_PROJECTS] = new TrainingProjectsStore(
        obj[STORE_ROUTER],
        obj[STORE_PROJECTS_ROOT_UI],
        obj[STORE_USERS],
        service,
        mlService,
        projectsService
    );

    obj[STORE_TRAINING_PROJECT_DASHBOARD] = new TrainingProjectDashboardStore(
        obj[STORE_TRAINING_PROJECTS],
        service,
        obj[STORE_ROUTER]
    );
}

export type TrainingProjectsStores = {
    [STORE_TRAINING_PROJECTS]?: TrainingProjectsStore;
    [STORE_TRAINING_PROJECT_DASHBOARD]?: TrainingProjectDashboardStore;
};
